import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useWindowSize } from "go-core/components/useWindowSize";
import { apiOrganization } from "../../../../../../../../services/Api/Organization/apiOrganization";
import { InvoiceApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	show: boolean;
	onHide: () => void;
	pdfLink: string;
	invoice: InvoiceApi;
}

enum ExportMode {
	EXPORT,
	PRINT,
}

const InvoicePdfPreviewModal = ({ pdfLink, onHide, show, invoice }: Props) => {
	const isMobile = useWindowSize().isMobile;
	const { t } = useTranslation();
	const { addFlash } = useFlash();

	const getInvoicePDFHandler = async (mode: ExportMode) => {
		try {
			const previewData = await apiOrganization.getInvoicePDFPreview(invoice.id);
			const fileURL = URL.createObjectURL(previewData);
			const link = document.createElement("a");
			if (mode === ExportMode.PRINT) {
				link.target = "_blank";
				link.rel = "noopener noreferrer";
			} else {
				link.download = `${t(`enums.invoices.document_type.${invoice.document_type}`)}_${invoice.number}.pdf`;
			}
			link.href = fileURL;
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const exportInvoiceToPDFHandler = async () => {
		await getInvoicePDFHandler(ExportMode.EXPORT);
	};

	const printInvoiceHandler = async () => {
		await getInvoicePDFHandler(ExportMode.PRINT);
	};

	return (
		<Modal show={show} onHide={onHide} size="lg" scrollable>
			<Modal.Header closeButton />
			<Modal.Body>
				<div className="w-100" style={{ height: isMobile ? 600 : 800 }}>
					<img src={pdfLink} alt="invoice-image" className="image w-100" />
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={exportInvoiceToPDFHandler}>{t("lib:common.action.export_pdf")}</Button>
				<Button onClick={printInvoiceHandler}>{t("lib:common.action.print")}</Button>
				<Button variant="light" onClick={onHide}>
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default InvoicePdfPreviewModal;
